import { Hero } from "@/components/hero";
import { InfoSection } from "@/components/info-section";
import { GuideSection } from "@/components/guide-section";
import { ActionCall } from "@/components/action-call";
import { FaqSection } from "@/components/faqs-section";
import AOSComponent from "@/components/aos";

export default function HomePage() {
  return (
    <AOSComponent>
      <div>
        <Hero />
        <InfoSection />
        <GuideSection />
        <ActionCall />
        <FaqSection />
      </div>
    </AOSComponent>
  );
}
